import { BehaviorSubject } from 'rxjs';

export class MockMessagingSocketService {
  public newMessageEvent$ = new BehaviorSubject<{
    id: string;
    threadId: string;
    senderId: string;
    isAdmin: boolean;
    content: string;
    createdAt: string;
  }>({
    id: '',
    threadId: '',
    senderId: '',
    isAdmin: false,
    content: '',
    createdAt: '',
  });
  public typingEvent$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public messageReadEvent$: BehaviorSubject<{ threadId: string; userId: string; lastReadMessageId: string }> =
    new BehaviorSubject<{ threadId: string; userId: string; lastReadMessageId: string }>({
      threadId: '',
      userId: '',
      lastReadMessageId: '',
    });

  public leaveThread(_threadId: string) {
    // Mock implementation
  }
}
